export default __webpack_public_path__ + "static/media/upload.098c85bc.svg";